import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaChevronLeft,
  FaChevronRight,
  FaHome,
  FaShieldAlt,
  FaSearch,
  FaChartLine,
  FaCogs,
  FaCloud,
  FaSignOutAlt,
  FaBars,
  FaClipboardCheck,
  FaNetworkWired,
} from "react-icons/fa";
import { signOut } from "aws-amplify/auth";
import { clearAppSession } from "../helper/storage";
import MobileMenu from "../component/MobileMenu";

const Sidebar = ({ isVisible, toggleSidebar, companyMode = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);


  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      sessionStorage.setItem('isLoggingOut', 'true');
      await signOut();
      clearAppSession(); // Safe cleanup instead of localStorage.clear()
      sessionStorage.clear();
      window.location.replace("/login");
    } catch (error) {
      console.error("Error during logout:", error);
      clearAppSession(); // Safe cleanup instead of localStorage.clear()
      sessionStorage.clear();
      window.location.replace("/login");
    }
  };
  

  const compressed = !isVisible;

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Sidebar Toggle Button */}
      <div
        style={{
          position: "absolute",
          top: isVisible
            ? window.innerWidth <= 576
              ? "30px" // For small screens
              : "60px" // For larger screens
            : window.innerWidth <= 576
              ? "30px" // For small screens
              : "60px", // For larger screens
          left: isVisible
            ? window.innerWidth <= 576
              ? "30px" // For small screens
              : "230px" // For larger screens
            : window.innerWidth <= 576
              ? "30px" // For small screens
              : "50px", // For larger screens
          zIndex: 1200,
        }}
      >
        <div
          className="btn-toggle"
          style={{
            backgroundColor: "#fff",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
          }}
        >
          <button
            className="sidebar-toggle"
            onClick={toggleSidebar}
            style={{
              backgroundColor: "#342EAD",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "27px",
              lineHeight: "10px",
              height: "27px",
              fontSize: "15px",
              display: "block",
            }}
          >
            {isVisible ? <FaChevronLeft /> : <FaChevronRight />}
          </button>
          <button
            className="mobile-menu-toggle"
            onClick={handleMobileMenuToggle}
            style={{
              backgroundColor: "#342EAD",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              fontSize: "15px",
              lineHeight: "10px",
              cursor: "pointer",
              display: "none",
            }}
          >
            <FaBars />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <MobileMenu
          isOpen={isMobileMenuOpen}
          toggleMenu={handleMobileMenuToggle}
          handleLogout={handleLogout}
        />
      )}

      {/* Sidebar */}
      <div
        className="sidebar"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: compressed ? "70px" : "250px",
          height: "100%",
          backgroundColor: "#342EAD",
          color: "#ecf0f1",
          transition: "width 0.3s ease, box-shadow 0.3s ease",
          boxShadow: "2px 0 5px rgba(170, 172, 242, 0.33)",
          overflow: "hidden",
        }}
      >
        {/* Logo */}
        <NavLink
          to={companyMode ? "/company/dashboard" : "/dashboard/home"}
          className="logo d-flex align-items-center justify-content-center my-4"
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            color: "#ecf0f1",
            gap: compressed ? "0" : "12px",
            transition: "gap 0.3s ease",
            textDecoration: "none",
            cursor: "pointer",
          }}
        >
          <img
            src="/images/image4.png"
            alt="Logo"
            style={{
              width: "70px",
              height: "70px",
            }}
          />
          {!compressed && <span>ODIR</span>}
        </NavLink>

        {/* Navigation Links */}
        <ul className="nav flex-column pt-4 p-2">
          <li className="nav-item">
            <NavLink to={companyMode ? "/company/dashboard" : "/dashboard/home"} className="nav-link">
              <FaHome />
              {!compressed && <span className="ms-2">Dashboard</span>}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={companyMode ? "/company/secureguard" : "/dashboard/secureguard"} className="nav-link">
              <FaShieldAlt />
              {!compressed && <span className="ms-2">Secure Guard</span>}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={companyMode ? "/company/cloudmap" : "/dashboard/cloudmap"} className="nav-link">
              <FaCloud />
              {!compressed && <span className="ms-2">Cloud Map</span>}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={companyMode ? "/company/fineops" : "/dashboard/fineops"} className="nav-link">
              <FaChartLine />
              {!compressed && <span className="ms-2">FinOps</span>}
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={companyMode ? "/company/well-architected" : "/dashboard/well-architected"} className="nav-link">
              <FaClipboardCheck />
              {!compressed && <span className="ms-2">Well-Architected</span>}
            </NavLink>
          </li>
        </ul>

        {/* Logout Button */}
        <div
          style={{
            position: "absolute",
            bottom: "20px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <NavLink
            to="#"
            className="nav-link logout-button mx-2"
            onClick={handleLogout}
            style={{ opacity: isLoggingOut ? 0.6 : 1, pointerEvents: isLoggingOut ? 'none' : 'auto' }}
          >
            <FaSignOutAlt />
            {!compressed && <span className="ms-2">{isLoggingOut ? 'Logging out...' : 'Logout'}</span>}
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
